var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHmHeardIslandandMcDonaldIslands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_19205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#00008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4844 0L45.0469 8.48438L33.6562 0H30V2.90625L41.25 11.2969L30 19.6406V22.5H33.75L45 14.1094L56.2031 22.5H60V19.6875L48.7969 11.3438L60 3V0H56.4844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.125 13.1719L30 20.625V22.5L42.7031 13.1719H40.125ZM48.75 14.1094L48.4688 15.75L57.4688 22.5H60L48.75 14.1094ZM30 0V0.140625L41.6719 8.95312L41.5781 6.89062L32.3438 0H30ZM60 0L48.7969 8.25H51.6094L60 1.96875V0Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7031 0V22.5H41.2031V0H48.7031ZM60 7.5V15H30V7.5H60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 9.04688V13.5469H30V9.04688H60ZM47.2031 0V22.5H42.7031V0H47.2031Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5934 37.1907L12.5152 37.4345L12.309 39.3563L13.6965 38.0063L15.0746 39.3657L14.8871 37.4438L16.809 37.2188L15.1871 36.1688L16.209 34.5282L14.3715 35.1376L13.7246 33.3095L13.059 35.1282L11.2309 34.5001L12.234 36.1501L10.6027 37.1907H10.5934ZM10.9402 26.2032L10.6871 24.9845L11.6059 24.1407L10.3684 24.0001L9.85273 22.8657L9.33711 24.0001L8.09961 24.1407L9.01836 24.9845L8.76524 26.2032L9.85273 25.5845L10.9402 26.2032ZM20.6996 20.5782L22.6027 20.7845L22.434 22.6876L23.784 21.3282L25.1715 22.6501L24.9465 20.747L26.8402 20.4938L25.2184 19.4813L26.2027 17.8407L24.3934 18.4782L23.7184 16.6876L23.0902 18.497L21.2715 17.9063L22.2934 19.5282L20.6902 20.5782H20.6996ZM1.59336 17.5032L3.55273 17.7563L3.3371 19.7157L4.75274 18.3376L6.15899 19.7251L5.96211 17.7563L7.92149 17.5313L6.26211 16.4532L7.30274 14.7751L5.42774 15.4032L4.77149 13.547L4.09649 15.4032L2.23086 14.7563L3.26211 16.4438L1.59336 17.5032ZM10.6027 9.6751L12.5434 9.89072L12.3652 11.8407L13.7434 10.4532L15.159 11.8032L14.934 9.8626L16.8746 9.6001L15.2152 8.56885L16.2184 6.89072L14.3715 7.5376L13.6871 5.70947L13.0496 7.55635L11.1934 6.94697L12.234 8.59697L10.6027 9.6751ZM38.0621 36.1595L42.3559 36.6657L41.9246 40.9688L44.9996 37.9314L48.0934 40.9501L47.634 36.647L51.9277 36.1032L48.2809 33.7782L50.5309 30.0845L46.4434 31.4907L44.9621 27.422L43.509 31.5001L39.4121 30.122L41.6902 33.797L38.0527 36.1501L38.0621 36.1595Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_19205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmHeardIslandandMcDonaldIslands);
export default __webpack_public_path__ + "static/media/hm Heard Island and McDonald Islands.fac5e01065412cc6ab86442e27dbe737.svg";
export { ForwardRef as ReactComponent };